





























































































































































































































































































































































































































import {Component, Prop, Model} from 'vue-property-decorator';
import CommonVue from '../models/commonVue';
import Lesson from '../api/lesson';
import Exercise from '../api/exercise';
import ApiList from '@/api/list';

import Modal from '@/components/Modal.vue';
import DropDownEntity from '@/components/DropDownEntity.vue';
import FieldTextRange from '../components/FieldTextRange.vue';
import EditIcon from '../components/icons/EditIcon.vue';

import FieldAudio from '../components/FieldAudio.vue';
import FieldImage from '../components/FieldImage.vue';
import FieldTranscriptArpabet from '../components/FieldTranscriptArpabet.vue';
import FieldSentenceLinks from '../components/FieldSentenceLinks.vue';
import FieldInternational from '../components/FieldInternational.vue';
import FieldVideos from '../components/FieldVideos.vue';
import FieldAltPhonemes from '../components/FieldAltPhonemes.vue';
import FieldHints from '../components/FieldHints.vue';
import FieldVideosI18n from '../components/FieldVideosI18n.vue';
import SpeakingAltContent from '../api/speakingAltContent';
import FieldAltNextExercise from '../components/FieldAltNextExercise.vue';

@Component({

    components: {
        'modal': Modal,
        'drop-down-entity': DropDownEntity,
        'field-text-range': FieldTextRange,
        'edit-icon': EditIcon,
        'field-audio': FieldAudio,
        'field-image': FieldImage,
        'field-transcript-arpabet': FieldTranscriptArpabet,
        'field-sentence-links': FieldSentenceLinks,
        'field-international': FieldInternational,
        'field-videos': FieldVideos,
        'field-videos-i18n': FieldVideosI18n,
        'field-phonemes': FieldAltPhonemes,
        'field-hints': FieldHints,
        'field-next-exercise': FieldAltNextExercise,
    },
})
export default class FieldAlternateSentence extends CommonVue {
    @Prop({type: Boolean, default: false}) public disabled?: boolean;
    @Prop({type: Number}) public moduleId!: number;
    @Prop({type: Number}) public exerciseId!: number;
    @Prop({type: Number}) public lessonId!: number;
    @Prop({type: Exercise}) public exercise!: Exercise;

    @Model() public speakingAltContents!: SpeakingAltContent[];
    public speaking_alt_content: SpeakingAltContent = null;
    public showSpeakingAltContent: boolean = false;
    public lessonList: ApiList<Lesson> = null;
    public exerciseList: ApiList<Exercise> = null;
    public showModal: boolean = false;

    public async beforeMount() {
        this.busy = true;
        this.error = false;

        this.busy = false;

    }

    public newAlternateSentence() {
        this.speaking_alt_content = new SpeakingAltContent();
        this.showModal = true;
    }


     public saveClicked() {
        if (!this.speaking_alt_content) {
            return;
        }

        this.busy = true;

        try {
            if (this.speaking_alt_content.state === 'created') {
                this.speakingAltContents.push(this.speaking_alt_content);
            }
            this.speaking_alt_content.state = 'updated';
            this.busy = false;
            this.showModal = false;
        } catch (e) {
            console.log(e);
            this.busy = false;
        }
    }

}
